<template>
  <div class="updataUser">
    <!-- 修改密码 -->
    <template v-if="type === 1">
      <ul class="list">
        <li class="list_item">
          <van-field
            placeholder="请输入您的当前密码"
            v-model="password.oldPassword"
            type="password"
          >
            <template #left-icon>
              <van-image class="img" :src="require('@/assets/images/icon_lock_03.png')" />
            </template>
          </van-field>
          <van-field
            placeholder="请输入您的新密码"
            v-model="password.newPassword"
            type="password"
          >
            <template #left-icon>
              <van-image class="img" :src="require('@/assets/images/icon_lock_03.png')" />
            </template>
          </van-field>
          <van-field
            placeholder="请再次输入您的新密码"
            v-model="password.againPassword"
            type="password"
          >
            <template #left-icon>
              <van-image class="img" :src="require('@/assets/images/icon_lock_02.png')" />
            </template>
          </van-field>
        </li>
      </ul>
    </template>
    <!-- 修改密码 -->

    <!-- 修改手机号 -->
    <template v-else-if="type === 2">
      <ul class="list">
        <li class="list_item">
          <van-field
            placeholder="请输入您的手机号码"
            v-model="mobile"
          >
            <template #left-icon>
              <van-image class="img" :src="require('@/assets/images/icon_phone_01.png')" />
            </template>
          </van-field>
          <van-field
            placeholder="请输入验证码"
            v-model="code"
          >
            <template #left-icon>
              <van-image class="img" :src="require('@/assets/images/icon_chield_01.png')" />
            </template>
            <template #right-icon>
              <GetCode ref="GetCode" :obj="{startText:'获取验证码'}" @click="getCode" />
            </template>
          </van-field>
        </li>
      </ul>
    </template>
    <!-- 修改手机号 -->

    <!-- 修改邮箱 -->
    <template v-else-if="type === 3">
      <ul class="list">
        <li class="list_item">
          <van-field
            placeholder="请输入您的邮箱号码"
            v-model="email"
          >
            <template #left-icon>
              <van-image class="img" :src="require('@/assets/images/icon_email_01.png')" />
            </template>
          </van-field>
          <van-field
            placeholder="请输入验证码"
            v-model="code"
          >
            <template #left-icon>
              <van-image class="img" :src="require('@/assets/images/icon_chield_01.png')" />
            </template>
            <template #right-icon>
              <GetCode ref="GetCode" :obj="{startText:'获取验证码'}" @click="getCode" />
            </template>
          </van-field>
        </li>
      </ul>
    </template>
    <!-- 修改邮箱 -->

    <div class="botton" @click="submit" v-if="type === 1">确认提交</div>
    <div class="botton" @click="submitMode" v-else-if="type === 2 || type === 3">确认修改</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Field } from 'vant';
import md5 from 'md5';
import { GetCode } from '@/components';
export default {
  components: {
    'van-field': Field,
    GetCode
  },
  data () {
    return {
      type: '', // 1：密码  2：手机   3：邮箱
      // 密码
      password: {
        oldPassword: '',
        newPassword: '',
        againPassword: ''
      },
      mobile: '',
      email: '',
      code: ''
    };
  },
  computed: {
    ...mapGetters(['personInfo']),
    user () {
      return this.personInfo.user;
    }
  },

  mounted () {
    let key = {
      1: {
        title: '账户与安全'
      },
      2: {
        title: '绑定手机号码'
      },
      3: {
        title: '绑定邮箱'
      }
    };
    const { $route: { meta, params } } = this;
    meta.title = key[params.type].title;
    this.type = params.type * 1;

    this.mobile = this.user.mobile ? this.user.mobile : '';
    this.email = this.user.email ? this.user.email : '';
  },
  methods: {

    /* 提交修改密码信息 */
    submit () {
      const { $http, $utils, $router, password } = this;
      if (
        $utils.verifyEmpty(password.oldPassword, '请输入原始密码') &&
        $utils.verifyEmpty(password.newPassword, '请输入修改密码') &&
        $utils.verifyEmpty(password.againPassword, '请输入再次输入密码') &&
        $utils.verifySame(password.newPassword, password.againPassword, '两次密码输入不一致!')
      ) {
        $http.put('security/modifyPassword', {
          newPassword: md5(password.newPassword),
          password: md5(password.oldPassword)
        }).then((res) => {
          $utils.successToast({
            message: '修改成功,请重新登录',
            onClose: () => {
              $utils.logOut();
              $router.push({
                name: 'Login'
              });
            }
          });
        });
      }
    },

    /* 发送验证码 */
    getCode () {
      const { $utils, type, $refs, $http } = this;
      let key, msg, url;
      switch (type) {
        case 1:
          break;
        case 2:
          key = 'mobile';
          msg = '请输入手机号码';
          url = 'mobile/sendRegisterCode';
          break;
        case 3:
          key = 'email';
          msg = '请输入邮箱';
          url = 'email/sendBindEmailCode';
          break;
      }
      if ($utils.verifyEmpty(this[key], msg)) {
        $refs.GetCode.toSend(() => {
          $http.get(url, { params: { [key]: this[key] }, showLoading: true }).then((res) => {
          });
        });
      }
    },

    /* 修改邮箱或者手机号 */
    submitMode () {
      const { $utils, $router, type, $http, code } = this;
      let key, msg, url;
      switch (type) {
        case 1:
          break;
        case 2:
          key = 'mobile';
          msg = '请输入手机号码';
          url = 'personal/bindMobild';
          break;
        case 3:
          key = 'email';
          msg = '请输入邮箱';
          url = 'personal/bindEmail';
          break;
      }
      if ($utils.verifyEmpty(this[key], msg) && $utils.verifyEmpty(code, '请输入验证码')) {
        $http.post(url, {
          [key]: this[key],
          [key + 'Code']: code
        }, {
          showLoading: true
        }).then((res) => {
          $utils.toast({
            message: res.msg,
            onClose: () => {
              $router.go(-1);
            }
          });
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
 .updataUser{
   padding: 40px 60px 0;
   .list{
     margin-bottom: 170px;
     .list_item{
       /deep/.van-field{
        width: 100%;
        height: 84px;
        background: #F6F6F6;
        border-radius: 10px;
        padding: 26px 0px 26px 40px;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        &:last-child{
          margin-bottom: 0;
        }
        .img{
          width: 32px;
          height: 32px;
          vertical-align: middle;
          margin-right: 44px;
        }
        .right{
          color: #2E86FF;
          margin-right: 40px;
        }
       }
     }
   }
   .botton{
      width: 450px;
      height: 76px;
      background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
      box-shadow: 0px 6px 40px rgba(95, 169, 255, 0.3);
      border-radius: 44px;
      font-size: 28px;
      line-height: 76px;
      color: #fff;
      text-align: center;
      margin: 0 auto;
   }
 }
</style>
